import React, { Component } from 'react'

export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <div>
          <nav href="#navbar" className="js-colorlib-nav-toggle colorlib-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-controls="navbar"><i /></nav>
          <aside id="colorlib-aside" className="border js-fullheight" >
		  
		  {/* Author Image and Email */}
            <div className="text-center">
              <div className="author-img" style={{backgroundImage: 'url(images/about.png)'}} />
              <h1 id="colorlib-logo"><a href="index.html">Alex Lu</a></h1>
              <span className="email"><i className="icon-mail"></i> thienlu.work@gmail.com</span>
            </div>
			
			{/* Navigation Bar */}
            <nav id="colorlib-main-menu" role="navigation" className="navbar">
              <div id="navbar" className="collapse">
                <ul>
                  <li className="active"><a href="#home" data-nav-section="home">Introduction</a></li>
                  <li><a href="#about" data-nav-section="about">About</a></li>
                  <li><a href="#timeline" data-nav-section="timeline">Timeline</a></li>
                </ul>
              </div>
            </nav>
			{/* Icon Links */}
            <nav id="colorlib-main-menu">
              <ul>
                <li><a href="https://www.linkedin.com/in/thienlu" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin2" /></a></li>
                {<li><a href="https://github.com/ThienLu" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i></a></li>}
              </ul>
            </nav>
			{/* Footer */}
            <div className="colorlib-footer">
              <p><small>
                  Made with React, HTML, CSS and javascript. <br/>
                  Thanks to <a href="https://colorlib.com" target="_blank" rel="noopener noreferrer">Colorlib</a> and dbarochiya!
              </small></p>
            </div>
          </aside>
        </div>
      </div>
    )
  }
}
